export const ONE_DAY_IN_MINUTES = 1440;
export const ONE_WEEK_IN_MINUTES = 10080;
